import { render, staticRenderFns } from "./Recrutamento.vue?vue&type=template&id=12fc73e9&scoped=true"
import script from "./Recrutamento.vue?vue&type=script&lang=js"
export * from "./Recrutamento.vue?vue&type=script&lang=js"
import style0 from "./Recrutamento.vue?vue&type=style&index=0&id=12fc73e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc73e9",
  null
  
)

export default component.exports